<template lang="pug">
nav.guest_menu
  template(v-for="item in options" :key="item.label")
    router-link.guest_menu__item(:to="{ name: item.route }" v-if="item.route")
      span.guest_menu__icon
        i(:class="item.icon" aria-hidden="true")
      span.guest_menu__label {{ item.label }}
    a.guest_menu__item(:href="`tel:${item.url}`" v-else)
      span.guest_menu__icon
        i(:class="item.icon" aria-hidden="true")
      span.guest_menu__label {{ item.label }}
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.guest_menu {
  @apply bg-white;
  @apply bg-opacity-80;
  @apply w-full;
  @apply rounded-2xl;
  @apply flex;
  @apply items-stretch;
  @apply overflow-hidden;
  @apply max-w-md;
  @apply border;
  @apply border-white;
  @apply shadow-bluegray-400-lg;

  &__item {
    @apply relative;
    @apply py-4;
    @apply px-2;
    @apply flex;
    @apply flex-1;
    @apply flex-col;
    @apply items-center;
    @apply justify-start;
    @apply gap-2;
    @apply outline-none;
    @apply transition-colors;
    @apply duration-200;

    & + .guest_menu__item::before {
      content: "";
      @apply absolute;
      @apply left-0;
      @apply top-4;
      @apply bottom-4;
      @apply w-px;
      @apply bg-bluegray-100;
    }

    &:hover {
      @apply bg-bluegray-50;
      .guest_menu__icon {
        @apply bg-gignetgreen-300;
      }
    }

    &:active {
      @apply bg-bluegray-100;
    }

    &:focus-visible {
      @apply bg-bluegray-50;
      .guest_menu__icon {
        @apply ring-2;
        @apply ring-gignetgreen-400;
      }
    }
  }

  &__icon {
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply h-11;
    @apply w-11;
    @apply rounded-xl;
    @apply bg-gignetgreen-200;
    @apply transition-all;
    @apply duration-200;

    i {
      @apply text-2xl;
      @apply leading-none;
      @apply text-gignetgreen-700;
    }
  }

  &__label {
    @apply text-center;
    @apply text-bluegray-500;
    @apply font-medium;
    @apply text-xs;
    @apply leading-tight;
  }
}
</style>
